/**
 * Migration Center (WP4-MIGRATE): Settings, Migration Center. The
 * Connect / Adopt / Migrate ladder per office, readiness Gates A to F with
 * evidence and sign-offs, parity, A/R reconciliation, the conversion
 * contract, the Open Dental fallback and the formal "Retire local PMS" run.
 * API: `/v1/migration`. Palette "Migration Center"; no G-sequence (G M is
 * Marketplace, BUILD-PLAN 3.6).
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'migration',
    title: 'Migration Center',
    version: '0.1.0',
    owner: 'WP4-MIGRATE',
    entitlementKey: null,
    permissions: ['settings.manage', 'offices.manage', 'patient.view'],
    routes: [
      {
        id: 'center',
        path: '/migration',
        title: 'Migration Center',
        permission: 'settings.manage',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Migration Center',
        group: 'settings',
        routeId: 'center',
        icon: 'layers',
        order: 940,
        permission: 'settings.manage',
      },
    ],
    commands: [
      {
        id: 'migration.open',
        title: 'Migration Center',
        keywords: [
          'retire',
          'local pms',
          'conversion',
          'readiness',
          'gates',
          'cutover',
          'connect adopt migrate',
        ],
        routeId: 'center',
        permission: 'settings.manage',
      },
      {
        id: 'migration.retire',
        title: 'Retire local PMS',
        keywords: ['migration', 'retire', 'open dental', 'dentrix', 'eaglesoft', 'read-only'],
        routeId: 'center',
        permission: 'settings.manage',
      },
      {
        id: 'migration.ar',
        title: 'A/R reconciliation',
        keywords: ['aging', 'month-end', 'day sheet', 'reconcile', 'gate d'],
        routeId: 'center',
        permission: 'settings.manage',
      },
    ],
    sseEntityKeys: ['pms_link'],
    phiReadPoints: ['migration.ar_families'],
  }),
  pages: {
    center: () => import('./MigrationPage.js'),
  },
});
